module.exports = __webpack_public_path__ + "static/media/qr_appcenter.6ea78bf3.jpg";